export default "__VITE_ASSET__Db$Z9KpB__"